module.exports = __webpack_public_path__ + "img/3화_16(2).46cb3657.jpg";